import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import WrapperContainer from "../../components/WrapperContainer/WrapperContainer.jsx";
import Button from "../../components/Button/Button.jsx";

import SvgIcon from "../../components/Icon/SvgIcon.jsx";
import Error from "../../features/Error.jsx";

import { apiCreateServices } from "../../api/methods/services.js";
import { APP_ROUTES } from "../../router";

import "./style.scss";

const OPTIONS = [
  { id: 0, label: "no", value: null },
  { id: 1, label: "yes", value: true },
];

const ConfirmInternetCable = () => {
  const history = useNavigate();

  const { mobileConnectionInfo } = useSelector(state => state);
  const [hasError, setHasError] = useState(false);

  const [activeOption, setActiveOption] = useState("");
  const [isExistCable, setIsExistCable] = useState(false);

  const changeAnswer = ({ label, value }) => {
    setActiveOption(label);
    setIsExistCable(value);
  };

  const createServices = async () => {
    try {
      const { apiKey, inetTariffId, ctvTariff, iptvTariff, cctvTariff, passphrase } =
        mobileConnectionInfo;

      await apiCreateServices(
        apiKey,
        inetTariffId,
        isExistCable,
        ctvTariff,
        iptvTariff,
        cctvTariff,
        passphrase
      );

      if (!inetTariffId) localStorage.removeItem("partnerProgram");
      history(APP_ROUTES.MOBILE_CONNECTION.PAYMENT_ROUTE);
    } catch {
      setHasError(true);
    }
  };

  if (hasError) return <Error />;

  return (
    <div>
      <WrapperContainer gap="24" title="sm">
        Проверьте наличие кабеля
      </WrapperContainer>

      <WrapperContainer gap="24" text="lg">
        <div className="selectable-wrapper-container">
          {OPTIONS.map(option => (
            <div
              className={`selectable-container${
                option.label === activeOption ? " selectable-container--active" : ""
              }`}
              key={option.id}
              onClick={() => changeAnswer(option)}
            >
              {option.id === 1 && (
                <>
                  <WrapperContainer gap="16">
                    <SvgIcon hasBg name="cableYes" color="#2a2e35" bg="#F4F4F4" />
                  </WrapperContainer>
                  <div>
                    <strong>У меня есть</strong> интернет кабель «АО Уфанет»
                  </div>
                </>
              )}
              {option.id === 0 && (
                <>
                  <WrapperContainer gap="16">
                    <SvgIcon hasBg name="cableNo" color="#2a2e35" bg="#F4F4F4" />
                  </WrapperContainer>
                  <div>
                    <strong>У меня нет</strong> интернет кабеля «АО Уфанет»
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </WrapperContainer>

      <Button isStretch color="primary" onClick={createServices} disabled={!activeOption}>
        Далее
      </Button>
    </div>
  );
};

export default ConfirmInternetCable;
